/* eslint-disable */
export default {
  status: 'État',
  acceptQueueCalls: 'Accepter les appels de la file d’attente',
  callQueueDisabledReason:
    'Ce paramètre est géré par l’administrateur de votre entreprise.',
  callQueueManagement: 'Gérer les files d’attente',
} as const;

// @key: @#@"status"@#@ @source: @#@"Status"@#@
// @key: @#@"acceptQueueCalls"@#@ @source: @#@"Accept call queue calls"@#@
// @key: @#@"callQueueDisabledReason"@#@ @source: @#@"This setting is managed by your company administrator."@#@
// @key: @#@"callQueueManagement"@#@ @source: @#@"Manage queues"@#@
